// fr.gestionpial.user.services.ResetPwdServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';

@Injectable({
  providedIn: 'root',
})
export class ResetPwdService {
  private irpc = inject(IRPC);

  changePassword = (token: string, password: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'ResetPwdService.changePassword';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(token, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(password, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  forgotPassword = (email: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'ResetPwdService.forgotPassword';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(email, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
